import React from 'react';
import ErrorMessage from '../../../Elements/ErrorMessage';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ApplyTpPaymentItem from '../../../Domain/ApplyTpPaymentItem';
import TpClientPaymentTpClientInvoiceSearchParams from './TpClientPaymentTpClientInvoiceSearchParams';
import TpClientPaymentService from '../../../Services/tpClientPaymentService';
import ClientInvoiceService from '../../../Services/ClientInvoiceService';
import TpRelatedClientInvoiceService from '../../../Services/TpRelatedClientInvoiceService';
import OutstandingTpRelatedInvoiceItem from '../../../Domain/OutstandingTpRelatedInvoiceItem';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import ApplyPartialTpRelatedClientPaymentWindowDescription from './ApplyPartialTpRelatedClientPaymentWindowDescription';

export default class OutstandingClientInvoiceAdmin extends React.Component {
  static defaultProps = {
    tpClientPaymentId: 0,
  };

  constructor(props) {
    super(props);

    this.state = {
      allItemsInTheSearchSetAreSelected: false,
      itemList: [],
      numberOfElementsInTheTable: 0,
      selectedItem: {},
      searchItem: new TpClientPaymentTpClientInvoiceSearchParams(
        props.tpClientPaymentId,
        'outstanding',
        'outstanding_tprelated'
      ),
      paymentType: 'Pre-Payment',
      isReversed: true,
    };

    this.refresh = this.refresh.bind(this);
    this.applyPaymentFunction = this.applyPaymentFunction.bind(this);
    this.applyPartialPaymentFunction = this.applyPartialPaymentFunction.bind(this);
  }

  componentDidMount() {
    this.setParentPaymentData();
  }

  setParentPaymentData() {
    TpClientPaymentService.GetByPaymentById(this.props.tpClientPaymentId)
      .then((result) => {
        if (result && result.error) {
          ErrorMessage.SetErrorMessage(result.error);
        } else {
          this.setState({
            paymentType: result.isPrepayment ? 'Pre-Payment' : 'Payment',
            isReversed: result.status === 'Reversed',
          });
        }
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('OCIA55', error);
      });
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem }, shownPanel: ShownPanelsEnum.None });
  }

  applyPartialPaymentFunction() {
    const selectedItem = new ApplyTpPaymentItem();
    selectedItem.AllItemsInTheSearchAreSelected = this.state.allItemsInTheSearchSetAreSelected;
    selectedItem.NumberOfItemsSelected = this.state.allItemsInTheSearchSetAreSelected
      ? this.state.numberOfElementsInTheTable
      : this.state.itemList.filter((x) => x.Selected === true).length;
    selectedItem.TpClientPaymentId = this.props.tpClientPaymentId;
    selectedItem.TpClientInvoiceIds = this.state.itemList.filter((x) => x.Selected === true).map((x) => x.CiId);
    selectedItem.InvoiceType = 'outstanding';
    selectedItem.TypeOfDistribution = 'Apply evenly';

    this.setState({
      shownPanel: ShownPanelsEnum.ApplyCredit,
      selectedItem,
    });
  }

  applyPaymentFunction() {
    const selectedItem = new ApplyTpPaymentItem();
    selectedItem.AllItemsInTheSearchAreSelected = this.state.allItemsInTheSearchSetAreSelected;
    selectedItem.NumberOfItemsSelected = this.state.allItemsInTheSearchSetAreSelected
      ? this.state.numberOfElementsInTheTable
      : this.state.itemList.filter((x) => x.Selected === true).length;
    selectedItem.TpClientPaymentId = this.props.tpClientPaymentId;
    selectedItem.TpClientInvoiceIds = this.state.itemList.filter((x) => x.Selected === true).map((x) => x.CiId);
    selectedItem.InvoiceType = 'outstanding';

    TpClientPaymentService.ApplyPaymentToOldInvoice(selectedItem)
      .then((result) => {
        if (result && result.error) {
          ErrorMessage.SetErrorMessage(result.error);
        } else {
          ErrorMessage.SetNotification('Payment applied from Invoice(s).');
        }
        ErrorMessage.SetLoading(false);
        this.refresh();
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('OCIA55', error);
        ErrorMessage.SetLoading(false);
      });
    ErrorMessage.SetLoading(true);
  }

  getNumberOfSelectedElements() {
    return this.state.itemList.filter((x) => x.Selected === true).length;
  }

  renderButtons() {
    return (
      <div>
        <FigmaButtonRow
          buttons={[
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Common,
              onClick: () => this.applyPartialPaymentFunction(),
              label: 'Apply Partial',
              tooltip: 'Apply Partial',
              roleKey: 'tp_clientpayment_apply',
              disabled:
                this.getNumberOfSelectedElements() === 0 ||
                this.state.isReversed,
            },
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Common,
              onClick: () => ErrorMessage.SetApprove(this.getApproveMessage(), this.applyPaymentFunction),
              label: 'Apply Full',
              tooltip: 'Apply Full',
              roleKey: 'tp_clientpayment_apply',
              disabled: this.getNumberOfSelectedElements() === 0 || this.state.isReversed,
            },
          ]}
        />
      </div>
    );
  }

  getApproveMessage() {
    if (this.state.allItemsInTheSearchSetAreSelected) {
      return `Apply the payment to all currently selected (${this.state.numberOfElementsInTheTable}) Client Invoices?`;
    }
    const idList = this.state.itemList.filter((x) => x.Selected === true).map((x) => x.CiId);
    return `Apply the payment to the selected ${idList.length} Client Invoice(s)?`;
  }

  renderOnePanel = (panelId, content) => (this.state.shownPanel === panelId ? content : null);

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.ApplyCredit,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh(true)}
            windowDescription={ApplyPartialTpRelatedClientPaymentWindowDescription}
            errorCode='OTCPA93'
          />
        )}
      </div>
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtons()}
        {this.renderPanels()}
        <TabOfDataTable
          type={OutstandingTpRelatedInvoiceItem}
          serviceFunction={TpRelatedClientInvoiceService.ListTpRelatedOutstanding}
          convertDBItemsFunction={ClientInvoiceService.ConvertOutstandingDBItems}
          searchItem={this.state.searchItem}
          searchParamsType={TpClientPaymentTpClientInvoiceSearchParams}
          orderBy='CiId'
          orderDirection='Desc'
          errorCode='OCIA109'
          changeOfItemListFunction={(itemList, numberOfElementsInTheTable) =>
            this.setState({ itemList, numberOfElementsInTheTable })
          }
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          forceClearCacheOnSearch={true}
        />
      </div>
    );
  }
}
